export const pickRandom = <T extends unknown>(array: T[]): T => array[
    Math.floor(Math.random() * array.length)
];
